import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DynamicQuestionnaireFields } from '@core/data-access/models/api/dynamic-questionnaire-fields.model';
import { TicketPersonId } from '@products/models/tariff.model';
import { environment } from '@src/environments/environment';
import { forEach } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireApiService {
  readonly #http = inject(HttpClient);

  getBuyerQuestionnaire$(ticketPersonIds: TicketPersonId[], selectedExhibitionId: number, isSelfRegistration: boolean) {
    let params = new HttpParams();

    params = params.append('sr', `${isSelfRegistration}`);

    forEach(ticketPersonIds, (ticketPersonId) => {
      params = params.append('ticketPersonIds', ticketPersonId);
    });

    return this.#http.get<DynamicQuestionnaireFields>(
      `${environment.protocol}${environment.webApiUrl}/event/${selectedExhibitionId}/buyer-questionnaire`,
      {
        params
      }
    );
  }

  getTicketHolderQuestionnaire$(
    ticketPersonIds: TicketPersonId[],
    selectedExhibitionId: number,
    isSelfRegistration: boolean
  ) {
    let params: HttpParams = new HttpParams();

    params = params.append('sr', `${isSelfRegistration}`);

    forEach(ticketPersonIds, (ticketPersonId) => {
      params = params.append('ticketPersonIds', ticketPersonId);
    });

    return this.#http.get<DynamicQuestionnaireFields>(
      `${environment.protocol}${environment.webApiUrl}/event/${selectedExhibitionId}/visitor-questionnaire`,
      {
        params
      }
    );
  }
}
